/**
 * Common object interface
 */
export interface CommonObject {
    [index: string]: any;
}

/**
 * Object utility method class
 */
export class ObjectUtils {

    /**
     * Object type check
     */
    public static isObject(object: unknown): boolean {
        return object === Object(object)
            && Object.prototype.toString.call(object) !== '[object Array]';
    }

    /**
     * DeepClone
     */
    public static deepClone(sourceObject: CommonObject): object {
        const clonedObject: CommonObject = {};

        for (const prop in sourceObject) {
            if (sourceObject.hasOwnProperty(prop)) {
                if (ObjectUtils.isObject(sourceObject[prop])) {
                    clonedObject[prop] = ObjectUtils.deepClone(sourceObject[prop]);
                } else {
                    clonedObject[prop] = sourceObject[prop];
                }
            }
        }

        return clonedObject;
    }

    /**
     * whatItDoes
     * performs deep clone through JSON manipulation
     */
    public static clone<T>(object: T): T {
        return JSON.parse(JSON.stringify(object));
    }

    /**
     * Parse object to array
     */
    public static parseObjectValuesToArray<T>(object: any): T[] {
        return Object.keys(object).map((key: any) => object[key]);
    }

    /**
     * Remove properties that are set as null or empty string
     */
    public static removeNullLikeProps<T>(source: T): T {
        const newObject = {};

        Object.entries(<unknown>source as { [s: string]: unknown}).forEach(([ key, value ]) => {
            if (this.isObject(value)) {
                Object.defineProperty(newObject, key, { value: this.removeNullLikeProps(value), enumerable: true });
            } else if (value !== null && value !== '' && value !== undefined) {
                Object.defineProperty(newObject, key, { value, enumerable: true });
            }
        });

        return newObject as T;
    }
}
